module.exports = __webpack_public_path__ + "static/workflow-categories-lg-145428b055711edbf186a7681b3d99a9.png";